
document.addEventListener('DOMContentLoaded',()=>{
  const openUseful=()=>document.querySelectorAll('[data-dealzo-default-open]').forEach(el=>el.setAttribute('open',''));
  openUseful();
  if(customElements.get('collapsible-details'))requestAnimationFrame(openUseful);
  else customElements.whenDefined('collapsible-details').then(openUseful);
  document.querySelectorAll('toolbar-mobile a[href]').forEach(link=>{
    const path=new URL(link.href,location.origin).pathname;
    if(path===location.pathname)link.setAttribute('aria-current','page');
    else link.removeAttribute('aria-current');
  });
});
